import { Status } from './status';

export class LDWDocument {
  public id = '';
  public name = '';
  public text = '';
  public status = new Status();
  public images: string[] = [];
  public treePath = '';
  public hasHistory = false;
}
